export enum HintDisplay {
  Always = 'ALWAYS',
  AfterFirstAttempt = 'AFTER_FIRST_ATTEMPT',
}

export enum HintBlockType {
  FreeText = 'FREE_TEXT',
  Choice = 'CHOICE',
  MultiChoice = 'MULTI_CHOICE',
  MultiTextarea = 'MULTI_TEXTAREA',
  FillBlanks = 'FILL_BLANKS',
  Pairing = 'PAIRING',
  Match = 'MATCH',
  UploadFile = 'UPLOAD_FILE',
  AudioPlayer = 'AUDIO_PLAYER',
  Highlight = 'HIGHLIGHT',
  Sort = 'SORT',
}
